export default "<p *ngIf=\"face\" [style.bottom]=\"bottom\" [style.left]=\"left\">\n    AgeRange = {{ face[AgeRange][Low] }} - {{ face[AgeRange][High] }}\n</p>"